goog.provide("shadow.js.shim.module$$mui$x_date_pickers$DatePicker");
goog.provide("module$shadow_js_shim_module$$mui$x_date_pickers$DatePicker");
shadow.js.shim.module$$mui$x_date_pickers$DatePicker = shadow.js.nativeProvides["@mui/x-date-pickers/DatePicker"] = shadow$bridge("@mui/x-date-pickers/DatePicker");
module$shadow_js_shim_module$$mui$x_date_pickers$DatePicker.default = shadow.js.shim.module$$mui$x_date_pickers$DatePicker;
